export const openFullScreen = (): void => {
  let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (!document.fullscreenElement && !isSafari) {
    document.documentElement.requestFullscreen();
  }
};
